import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PreCallInfo } from '@nimbus-assistant/enums/pre-call-info';
import { SettingsService } from '@nimbus-assistant/services/settings.service';
import { Features } from '@nimbus-assistant/enums/features';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { Language } from '../../../enums/language';

@Component({
  standalone: false,
  selector: 'app-settings-general-tab',
  templateUrl: './settings-general-tab.component.html',
  styleUrls: ['./settings-general-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsGeneralTabComponent implements OnInit {
  @Input()
  public formGroupName: string;
  public form: FormGroup;

  public TranslationKeys = TranslationKeys;

  public preCallInfoEnabled: boolean;

  public languages = [
    { id: Language.en, name: this.translateService.instant(TranslationKeys.LanguageSelectorEnglish) },
    { id: Language.de, name: this.translateService.instant(TranslationKeys.LanguageSelectorGerman) },
    { id: Language.da, name: this.translateService.instant(TranslationKeys.LanguageSelectorDanish) },
    { id: Language.es, name: this.translateService.instant(TranslationKeys.LanguageSelectorSpanish) },
    { id: Language.fr, name: this.translateService.instant(TranslationKeys.LanguageSelectorFrench) },
    { id: Language.it, name: this.translateService.instant(TranslationKeys.LanguageSelectorItalian) },
    { id: Language.nl, name: this.translateService.instant(TranslationKeys.LanguageSelectorDutch) },
  ];

  public preCallInfoTabs = [
    { id: PreCallInfo.CallFlow, name: this.translateService.instant(TranslationKeys.SettingsPreCallInfoCallFlow) },
    { id: PreCallInfo.Info, name: this.translateService.instant(TranslationKeys.SettingsPreCallInfoInfo) },
  ];

  public constructor(
    private rootFormGroup: FormGroupDirective,
    private readonly translateService: TranslateService,
    private readonly settingsService: SettingsService,
  ) {}

  public ngOnInit(): void {
    this.preCallInfoEnabled = this.settingsService.supportsFeature(Features.PreCallInfo);
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }
}
